import { useMemo } from 'react';
// import { useQuery } from 'react-query';
// import * as api from '../../services/api';
import fileTypesMock from './mocks/fileTypes.json';

const useFileTypes = () => {
  // const storeKey = ['fileTypes'];
  // const { isLoading, data } = useQuery(storeKey, api.fetchFileTypes);
  const isLoading = false;
  const data = fileTypesMock;

  const fileTypes = useMemo(() => (data?.data || []).map(({ id, name }) => ({ value: id, label: name })), [data?.data]);

  const mappedFileTypes = useMemo(
    () => fileTypes.reduce((prev, { value, label }) => ({ ...prev, [value]: label }), {}),
    [fileTypes]
  );

  return { isLoading, mappedFileTypes, fileTypes };
};

export default useFileTypes;
